import {ApplicationRef, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import {AppComponent} from './app.component';
import {createNewHosts, removeNgStyles} from '@angularclass/hmr';
import {Stormpath, StormpathConfiguration} from 'angular-stormpath';
import {STORMPATH_CONFIG} from './infrastructure/security/stormpath/stormpath.config';
import {NavModule} from './navigation/nav.module';
import {SecurityModule} from './components/security/security.module';
import {FooterModule} from './footer/footer.module';
import '../style/main.scss';
import {PageContentModule} from './pages/page-content.module';
import {ProfileModule} from './domain/model/profile/profile.module';
import {DomainModule} from './domain/domain.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app.routing';
import {FileModule} from './components/files/service/file.module';
import {RecaptchaModule} from 'ng2-recaptcha';
import {StompRService} from '@stomp/ng2-stompjs';
import {LocalStorageModule} from './infrastructure/local-storage/local-storage.module';
import {StormpathModule} from './infrastructure/security/stormpath/stormpath.module';
import {NgIdleModule} from '@ng-idle/core';
import {ToastyModule} from 'ng2-toasty';
import {MessagesModule} from './components/messages/messages.module';
import {OCrModule} from './components/ocr/ocr.module';
import {WebsocketService} from './components/websocket/websocket.service';

@NgModule({
    imports: [
        BrowserModule,
        StormpathModule,
        HttpModule,
        LocalStorageModule,
        SecurityModule,
        FileModule,
        OCrModule,
        NgbModule.forRoot(),
        RecaptchaModule.forRoot(),
        NgIdleModule.forRoot(),
        ToastyModule.forRoot(),
        AppRoutingModule,
        MessagesModule,
        DomainModule,
        ProfileModule,
        FooterModule,
        NavModule,
        PageContentModule
    ],
    declarations: [
        AppComponent
    ],
    providers: [
        {provide: StormpathConfiguration, useValue: STORMPATH_CONFIG},
        Stormpath,
        StompRService,
        WebsocketService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(public appRef: ApplicationRef) {
    }

    hmrOnInit(store) {
        console.log('HMR store', store);
    }

    hmrOnDestroy(store) {
        let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
        // recreate elements
        store.disposeOldHosts = createNewHosts(cmpLocation);
        // remove styles
        removeNgStyles();
    }

    hmrAfterDestroy(store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts